module.exports = __webpack_public_path__ + "static/media/icon-checkbox.71892b34.svg";